import sortBy from 'lodash/sortBy';

import {
  ACTIVITIES_COMPONENT_TYPE_COLUMNS,
  ACTIVITIES_COMPONENT_TYPE_GIF,
  ACTIVITIES_COMPONENT_TYPE_IMAGE,
} from 'global/constants';
import {
  ComponentColumns,
  ComponentGif,
  ComponentImage,
} from '../components/component.constants';
import { SectionOrSubSection } from '../activity-builder.constants';

type ImageComponents = ComponentImage | ComponentGif;

export function findImageComponents(
  section: SectionOrSubSection | undefined
): ImageComponents[] {
  const images: ImageComponents[] = [];

  sortBy(section?.components, 'sort').forEach(cmp => {
    if (
      cmp.type === ACTIVITIES_COMPONENT_TYPE_IMAGE ||
      cmp.type === ACTIVITIES_COMPONENT_TYPE_GIF
    ) {
      images.push(cmp as ImageComponents);
    }
    if (cmp.type === ACTIVITIES_COMPONENT_TYPE_COLUMNS) {
      const columns = cmp as ComponentColumns;
      columns.columns?.forEach(column => {
        sortBy(column.components, 'sort').forEach(cmp => {
          if (
            cmp.type === ACTIVITIES_COMPONENT_TYPE_IMAGE ||
            cmp.type === ACTIVITIES_COMPONENT_TYPE_GIF
          ) {
            images.push(cmp as ImageComponents);
          }
        });
      });
    }
  });

  return images.filter(
    img =>
      ('stimulusResourceProperties' in img &&
        img.stimulusResourceProperties?.image?.original) ||
      img.properties?.image
  );
}
